import {WEB_METHODS, transmission} from '../../network/index'

const SEND_CERTIFICATION = '/apis/v1/messages/sms/after-send/certification-number'
const SEND_EMAIL_CERTIFICATION = '/apis/v1/messages/email/after-send/certification-number'
const CONFIRM_CERTIFICATION = '/apis/v1/messages/certification/confirm'
const CONFIRM_EMAIL_CERTIFICATION = '/apis/v1/messages/email/certification/confirm'

const state = {
}

const mutations = {
}

const actions = {
  /**
   * 인증번호 발송
   * @param commit
   * @param payload
   * @returns {Promise<void>}
   */
  // eslint-disable-next-line no-unused-vars
  async postSendCertificationNumber ({commit}, payload) {
    return transmission(false, WEB_METHODS.POST, SEND_CERTIFICATION, payload)
  },
  /**
   * 인증번호 이메일 발송
   * @param commit
   * @param payload
   * @returns {Promise<void>}
   */
  // eslint-disable-next-line no-unused-vars
  async postSendEmailCertificationNumber ({commit}, payload) {
    return transmission(false, WEB_METHODS.POST, SEND_EMAIL_CERTIFICATION, payload)
  },
  /**
   * 인증번호 확인
   * @param commit
   * @param payload
   * @returns {Promise<void>}
   */
  // eslint-disable-next-line no-unused-vars
  async postConfirmCertificationNumber ({commit}, payload) {
    return transmission(false, WEB_METHODS.POST, CONFIRM_CERTIFICATION, payload)
  },
  /**
   * 이메일 인증번호 확인
   * @param commit
   * @param payload
   * @returns {Promise<void>}
   */
  // eslint-disable-next-line no-unused-vars
  async postConfirmEmailCertificationNumber ({commit}, payload) {
    return transmission(false, WEB_METHODS.POST, CONFIRM_EMAIL_CERTIFICATION, payload)
  }
}

export default { state, mutations, actions }
